import { mainApi } from "services/main";
import { toAuditDateString } from "components/create-audit-form/utils";
import { Audit } from "models/generateAuditSchemas";

const updateAuditResponse = (result: any) => {
  return toAuditDateString(result.audit);
};
const extendedApi = mainApi.injectEndpoints({
  endpoints: (builder) => ({
    updateAudit: builder.mutation<Audit, Audit>({
      query: (request?: Audit) => ({
        url: "audit",
        body: request,
        method: "PUT",
      }),
      transformResponse: updateAuditResponse,
      invalidatesTags: ["ActivityLogs"],
    }),
  }),
  overrideExisting: false,
});

export const { useUpdateAuditMutation } = extendedApi;
